import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "./authentication.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService {
  private router = inject(Router);
  private authService = inject(AuthenticationService);


  canActivate() {
    if (this.authService.userIsLoggedIn()) {
      return true;
    }

    return this.router.parseUrl("/login");
  }
}
